export default __webpack_public_path__ + "static/media/events-bg.ff1ca89d.svg";